(() => {
  if (window.parkJournalReady) return;
  window.parkJournalReady = true;
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('[data-park-blog-more]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const blog = link.closest('.park-blog');
    const grid = blog?.querySelector('[data-park-blog-grid]');
    if (!grid) return;
    event.preventDefault();
    if (link.getAttribute('aria-disabled') === 'true') return;
    const label = link.textContent;
    link.setAttribute('aria-disabled', 'true');
    link.textContent = link.dataset.loading;
    grid.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(link.href, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Article page unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const incoming = page.querySelector('[data-park-blog-grid]');
      const pagination = page.querySelector('[data-park-blog-pagination]');
      if (!incoming || !incoming.children.length || !pagination) throw new Error('Missing articles');
      const cards = Array.from(incoming.children);
      cards.forEach(card => grid.append(document.importNode(card, true)));
      const firstLink = grid.children[grid.children.length - cards.length]?.querySelector('h2 a');
      blog.querySelector('[data-park-blog-pagination]').replaceWith(document.importNode(pagination, true));
      const status = blog.querySelector('[data-park-blog-status]');
      if (status) status.textContent = status.dataset.message;
      firstLink?.focus({ preventScroll: true });
    } catch {
      window.location.assign(link.href);
    } finally {
      grid.removeAttribute('aria-busy');
      if (link.isConnected) {
        link.removeAttribute('aria-disabled');
        link.textContent = label;
      }
    }
  });
})();
